var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverbased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.7773V19.9996",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7222 12.0004L4.72217 10.2227",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2778 12.0004L20.2778 10.2227",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12C4.5 13.0506 4.70693 14.0909 5.10896 15.0615C5.511 16.0321 6.10028 16.914 6.84315 17.6569C7.58601 18.3997 8.46793 18.989 9.43853 19.391C10.4091 19.7931 11.4494 20 12.5 20C13.5506 20 14.5909 19.7931 15.5615 19.391C16.5321 18.989 17.414 18.3997 18.1569 17.6569C18.8997 16.914 19.489 16.0321 19.891 15.0615C20.2931 14.0909 20.5 13.0506 20.5 12C20.5 10.9494 20.2931 9.90914 19.891 8.93853C19.489 7.96793 18.8997 7.08601 18.1569 6.34315C17.414 5.60028 16.5321 5.011 15.5615 4.60896C14.5909 4.20693 13.5506 4 12.5 4C11.4494 4 10.4091 4.20693 9.43853 4.60896C8.46793 5.011 7.58601 5.60028 6.84315 6.34315C6.10028 7.08601 5.511 7.96793 5.10896 8.93853C4.70693 9.90914 4.5 10.9494 4.5 12Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7222 12.0004C10.7222 12.4719 10.9095 12.9241 11.2429 13.2575C11.5763 13.5909 12.0284 13.7782 12.4999 13.7782C12.9714 13.7782 13.4236 13.5909 13.757 13.2575C14.0904 12.9241 14.2777 12.4719 14.2777 12.0004C14.2777 11.5289 14.0904 11.0768 13.757 10.7434C13.4236 10.41 12.9714 10.2227 12.4999 10.2227C12.0284 10.2227 11.5763 10.41 11.2429 10.7434C10.9095 11.0768 10.7222 11.5289 10.7222 12.0004Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverbased);
export default __webpack_public_path__ + "static/media/driverbased.a99a8f16acd2c9b3351e3efe27740dff.svg";
export { ForwardRef as ReactComponent };